import { Winner } from "@/features/winners/models/winner";
import { formatShortNameWithState } from "@/lib/utils";

function PreviousPrize({ winner }: { winner: Winner }) {
	const baseURL = import.meta.env.VITE_SERVER_API_URL;
	const prizeImage = `${baseURL}/common/image/${winner.promotion?.prize?.images[0].url}`;
	const winnerPhoto = winner.photo
		? `${baseURL}/common/image/${winner.photo}`
		: prizeImage;

	return (
		<div className="flex flex-col gap-8 text-left">
			<img
				src={winnerPhoto}
				alt={winner.promotion.prize.title}
				className="h-50 w-full rounded-[32px] object-cover md:h-113"
			/>
			<div className="flex flex-col gap-2">
				<p className="web-heading-h4">{winner.promotion.prize.title}</p>
				<span className="web-body-b1-medium">
					Winner:{" "}
					<span className="web-body-b1 text-gray-700">
						The prize {winner.promotion.prize.title} valued at $
						{winner.promotion.prize.cost.toLocaleString()} was won by{" "}
						{formatShortNameWithState(
							winner.winner.fullName,
							winner.winner.stateName
						)}
					</span>
				</span>
			</div>
		</div>
	);
}

export default PreviousPrize;
